import React from "react";

const CaseStudiesHero = () => {
    return (
        <>
            <section className="cs-hero">

                <div className="cs-glow glow-1"></div>
                <div className="cs-glow glow-2"></div>

                <div className="cs-container">

                    <div className="cs-left">

                        <span className="cs-badge">
                            🚀 REAL RESULTS • REAL PRODUCTS
                        </span>

                        <h1>
                            Case
                            <br />
                            Studies
                        </h1>

                        <p>
                            Explore how AppVerseLabs transforms ideas into
                            high-performing digital products that drive
                            growth, engagement and measurable business results.
                        </p>

                        <div className="cs-actions">

                            <a href="#">
                                View Projects →
                            </a>

                            <a href="#">
                                Start Your Project
                            </a>

                        </div>

                        <div className="cs-stats">

                            <div>
                                <h3>50+</h3>
                                <span>Projects</span>
                            </div>

                            <div>
                                <h3>98%</h3>
                                <span>Satisfaction</span>
                            </div>

                            <div>
                                <h3>10M+</h3>
                                <span>Users Reached</span>
                            </div>

                        </div>

                    </div>

                    <div className="cs-right">

                        <div className="cs-main-card">

                            <div className="project-tag">
                                FEATURED PROJECT
                            </div>

                            <h3>
                                FinTech
                                <br />
                                Platform
                            </h3>

                            <p>
                                Increased transaction volume by
                                320% through a scalable financial ecosystem.
                            </p>

                            <div className="project-result">
                                +320% Growth
                            </div>

                        </div>


                        <div className="floating-card card-2">
                            🛒 E-Commerce Platform
                        </div>

                    </div>

                </div>

                <style>{`

                .cs-hero{
                    position:relative;
                    overflow:hidden;
                    background:#fff;
                    padding:150px 24px;
                }

                .cs-container{
                    max-width:1350px;
                    margin:auto;
                    display:grid;
                    grid-template-columns:1fr 1fr;
                    gap:70px;
                    align-items:center;
                    position:relative;
                    z-index:2;
                }

                .cs-badge{
                    display:inline-flex;
                    align-items:center;
                    padding:12px 22px;
                    border-radius:999px;
                    background:rgba(232,33,42,.08);
                    color:#E8212A;
                    font-size:13px;
                    font-weight:700;
                    letter-spacing:1px;
                    margin-bottom:30px;
                }

                .cs-left h1{
                    font-size:clamp(50px,10vw,100px);
                    line-height:.9;
                    color:#111;
                    font-weight:800;
                    margin-bottom:25px;
                    letter-spacing:-6px;
                    font-family:'Syne',sans-serif;
                }

                .cs-left p{
                    max-width:650px;
                    color:#666;
                    font-size:18px;
                    line-height:1.9;
                    margin-bottom:35px;
                    font-family:'Plus Jakarta Sans',sans-serif;
                }

                .cs-actions{
                    display:flex;
                    gap:16px;
                    flex-wrap:wrap;
                    margin-bottom:50px;
                }

                .cs-actions a:first-child{
                    padding:16px 30px;
                    border-radius:16px;
                    text-decoration:none;
                    color:#fff;
                    font-weight:700;

                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );

                    box-shadow:
                    0 20px 50px rgba(232,33,42,.25);
                }

                .cs-actions a:last-child{
                    padding:16px 30px;
                    border-radius:16px;
                    text-decoration:none;
                    color:#111;
                    font-weight:700;
                    border:1px solid #eee;
                }

                .cs-stats{
                    display:flex;
                    gap:60px;
                    flex-wrap:wrap;
                }

                .cs-stats h3{
                    font-size:50px;
                    margin-bottom:8px;
                    color:#111;
                    font-family:'Syne',sans-serif;
                }

                .cs-stats span{
                    color:#666;
                    font-size:14px;
                }

                .cs-right{
                    position:relative;
                    height:650px;
                }

                .cs-main-card{
                    position:absolute;
                    inset:50px;
                    border-radius:40px;
                    padding:50px;

                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );

                    color:#fff;

                    box-shadow:
                    0 50px 120px rgba(232,33,42,.25);

                    animation:floatMain 6s infinite ease-in-out;
                }

                .project-tag{
                    display:inline-block;
                    padding:10px 18px;
                    border-radius:999px;
                    background:rgba(255,255,255,.15);
                    margin-bottom:30px;
                    font-size:12px;
                    font-weight:700;
                }

                .cs-main-card h3{
                    font-size:60px;
                    line-height:1;
                    margin-bottom:20px;
                    font-family:'Syne',sans-serif;
                }

                .cs-main-card p{
                    line-height:1.8;
                    max-width:340px;
                    opacity:.9;
                }

                .project-result{
                    position:absolute;
                    bottom:40px;
                    left:50px;
                    font-size:44px;
                    font-weight:800;
                    font-family:'Syne',sans-serif;
                }

                .floating-card{
                    position:absolute;
                    background:#fff;
                    padding:18px 24px;
                    border-radius:20px;
                    font-weight:700;
                    color:#111;
                    box-shadow:
                    0 20px 60px rgba(0,0,0,.08);
                }

                .card-1{
                    top:0;
                    left:0;
                    animation:float1 4s infinite ease-in-out;
                }

                .card-2{
                    top:120px;
                    right:0;
                    animation:float2 5s infinite ease-in-out;
                }

                .card-3{
                    bottom:20px;
                    right:40px;
                    animation:float3 6s infinite ease-in-out;
                }

                .cs-glow{
                    position:absolute;
                    border-radius:50%;
                    filter:blur(120px);
                    opacity:.12;
                }

                .glow-1{
                    width:500px;
                    height:500px;
                    background:#E8212A;
                    left:-200px;
                    top:-200px;
                }

                .glow-2{
                    width:450px;
                    height:450px;
                    background:#FF4D4D;
                    right:-150px;
                    bottom:-150px;
                }

                @keyframes floatMain{
                    0%,100%{
                        transform:translateY(0);
                    }
                    50%{
                        transform:translateY(-15px);
                    }
                }

                @keyframes float1{
                    0%,100%{
                        transform:translateY(0);
                    }
                    50%{
                        transform:translateY(-12px);
                    }
                }

                @keyframes float2{
                    0%,100%{
                        transform:translateY(0);
                    }
                    50%{
                        transform:translateY(10px);
                    }
                }

                @keyframes float3{
                    0%,100%{
                        transform:translateY(0);
                    }
                    50%{
                        transform:translateY(-15px);
                    }
                }

                @media(max-width:991px){

                    .cs-container{
                        grid-template-columns:1fr;
                    }

                    .cs-right{
                        height:550px;
                    }

                }

                @media(max-width:768px){

                    .cs-hero{
                        padding:110px 18px;
                    }

                    .cs-left h1{
                        letter-spacing:-3px;
                    }

                    .cs-main-card{
                        inset:20px;
                        padding:30px;
                    }

                    .cs-main-card h3{
                        font-size:42px;
                    }

                    .project-result{
                        font-size:30px;
                        left:30px;
                    }

                    .cs-stats{
                        gap:30px;
                    }

                    .cs-stats h3{
                        font-size:36px;
                    }

                }

            `}</style>

            </section>
        </>
    );
};

export default CaseStudiesHero;